<ng-template #download let-modal>
  <div class="modal-body text-center p-0 download-popup" (mousedown)="clicked($event)" (touchstart)="clicked($event)">
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>

      <div class="row g-0">
        <!-- Mobile: Show right pane first (top), Desktop: Show left pane first (left) -->
        <div class="col-12 col-lg-6 right-pane right-pane-wide order-1 order-lg-2">
          <div class="slide" [ngClass]="slideClass" [style.backgroundImage]="'url(' + getSlideImage(slideNo) + ')'"></div>
          <div *ngIf="slideNo === 2" class="attending bg-white mx-3">
            <img src="/assets/images/df/download/attending_3.png" alt="">
            Join 3 friends
          </div>
        </div>

        <div class="col-12 col-lg-6 left-pane pt-4 pt-md-5 pb-3 px-4 order-2 order-lg-1">
          <owl-carousel-o #carousel [options]="downloadSlides" (changed)="slideChanged($event)" class="dl-carousel">
            <ng-template carouselSlide *ngFor="let slide of signupConfig.slides; let i = index">
              <div class="bg-white p-1 dl-slide mx-md-auto">
                <h4 class="fs-2" [innerHTML]="slide.title | linebreaks"></h4>
                <div class="mt-3 mt-md-4" [innerHTML]="slide.description | linebreaks"></div>

                <div class="mt-3 mt-md-4"></div>
                <df-download-options [showStoreLinks]="slide.showStoreLinks" [slideConfig]="slide" (closeModal)="dismiss()"></df-download-options>
                <div class="mt-3 mt-md-4"></div>
              </div>
            </ng-template>
          </owl-carousel-o>
        </div>
      </div>
  </div>
</ng-template>
